import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../apiSetup/apiCall';

export const fetchAddChargerForm = createAsyncThunk('addCharger/fetchAddChargerForm', async (stationId,{rejectWithValue}) => {
    try {
        const response = await api.get(`prometheus/station/${stationId}/charger/add/`);
        return response.data;
    } catch (error) {
        console.error('Error fetching charger form', error);
        throw rejectWithValue(error);
    }
    });

const AddChargerSlice = createSlice({
  name: 'addCharger',
  initialState: {
    data: [],
    isLoading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAddChargerForm.pending, (state) => {
        state.isLoading = true;
        state.error = false
      })
      .addCase(fetchAddChargerForm.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(fetchAddChargerForm.rejected, (state, action) => {
        state.isLoading = false;
        state.data = []
        state.error = true
      });
  },
});

export default AddChargerSlice.reducer;
